<script lang="ts">
    import Help16 from "carbon-icons-svelte/lib/Help16";

    export let title: string | null = '';
    export let tooltip: boolean = false;
    export let onTooltipClick: () => void = () => {};
</script>

<style>
    .section-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .content {
        box-sizing: border-box;
        width: 100%;
        box-shadow: -2px 4px 10px #1A31781A;
        border: 0.25px solid #CEDCFE;
        border-radius: 0.75em;
    }
    .title-container {
        display: flex;
        align-items: center;
    }
    .title {
        font-size: 22px;
        margin-left: 0.83em;
        margin-right: 0.4em;
        color: #141414;
    }
    .help-icon-container {
        color: #909090;
    }
</style>

<main>
    <div class="section-wrapper">
        <div class="content">
            <div class="title-container">
                <h2 class="title">{title}</h2>
                {#if tooltip}
                    <div class="help-icon-container" on:click={onTooltipClick}>
                        <Help16 />
                    </div>
                {/if}
            </div>
            <slot />
        </div>
    </div>
</main>
